<template>
  <a-modal v-model="visible" width="70%" :title="$t('页面信息')">
    <div slot="footer">
      <a-button type="default" @click="() => visible = false">{{ $t('确定') }}</a-button>
    </div>
    <a-descriptions :column="1" bordered>
      <a-descriptions-item :label="$t('页面名称')">{{ item.name }}</a-descriptions-item>
      <a-descriptions-item :label="$t('页面目录')">{{ item.folderName }}</a-descriptions-item>
      <a-descriptions-item :label="$t('页面地址')"><a @click="handleDispatch(pageUrl)">{{ pageFullUrl }}</a></a-descriptions-item>
      <a-descriptions-item :label="$t('二维码')">
        <VueQR :text="pageFullUrl" :size="190" :margin="0" ref="qr" />
        <div style="text-align: center; margin-top: 20px; width: 190px;">
          <a-button type="primary" @click="handleDownloadQr">{{ $t('下载') }}</a-button>
        </div>
      </a-descriptions-item>
    </a-descriptions>
  </a-modal>
</template>
<script>
import VueQR from 'vue-qr'
import RouteQueryMixins from '@/mixins/RouteQueryMixins'

export default {
  components: {
    VueQR
  },
  data() {
    return {
      visible: false,
      item: {}
    }
  },
  mixins: [RouteQueryMixins],
  computed: {
    pageUrl() {
      const pageKey = this.buildPageKey(this.item.appId, this.item.id)
      return `/app/review/page?pageKey=${pageKey}`
    },
    pageFullUrl() {
      const baseUrl = location.href.split('#')[0]
      return `${baseUrl}#${this.pageUrl}`
    },
  },
  methods: {
    show(data) {
      this.item = { ...data }
      this.visible = true
    },
    handleDispatch(path) {
      const baseUrl = location.href.split('#')[0]
      window.open(`${baseUrl}#${path}`, '_blank')
    },
    handleDownloadQr() {
      console.log(this.$refs.qr)
      const a = document.createElement('a')
      a.href = this.$refs.qr.imgUrl
      a.download = `${this.item.name}_二维码`
      a.click()
    }
  }
}
</script>
<style lang="less" scoped>
.link-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  div {
    width: 170px;
  }
}
</style>